import { render, staticRenderFns } from "./UseTemplateIcon.vue?vue&type=template&id=c8b1741e&"
import script from "./UseTemplateIcon.vue?vue&type=script&lang=js&"
export * from "./UseTemplateIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports